export default __webpack_public_path__ + "static/media/productImageBlue.8716c358.png";